import * as uuid from 'uuid';

export class GUID {
  public static newGUID() {
    const id = uuid.v4();
    return id;
  }
}
